import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useRemoveProductsFromPlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ product_ids }: { product_ids: number[] }) =>
      await apiClient.removeProductsFromPricingPlan(product_ids),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["pricing_plans"],
      });
      void queryClient.invalidateQueries({
        queryKey: ["product_report"],
      });
      void queryClient.invalidateQueries({
        queryKey: [{ entity: "pricing_plans" }],
      });
      void queryClient.invalidateQueries({
        queryKey: [{ endpoint: "/api/data_report/product_report" }],
      });
    },
  });
};
